import {Alert, Container, Header} from "@amzn/awsui-components-react";
import * as React from 'react';
import styled from "styled-components";


const ReportNotFoundDiv = styled.div`
  margin: 0;
  padding: 0;
  display: grid;
  width: 100%;
  height: 90vh;
  overflow: hidden;
  place-content: center;
  align-items: center;
`;

export const ReportNotFound = () => {
  return (
    <ReportNotFoundDiv>
      <Container header={<Header variant="h2">Report Not Found</Header>}>
        <Alert type={"error"}>
          This report does not seem to exist.
        </Alert>
      </Container>
    </ReportNotFoundDiv>
  );
}